import * as React from "react";

export const BuscaNotaIcon = () => {
	return (
		<svg width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.4103 31.2364C13.9706 31.676 13.3742 31.9229 12.7525 31.9229C12.1307 31.9229 11.5344 31.676 11.0947 31.2364L2.6861 22.8294C2.4682 22.6116 2.29535 22.3531 2.17741 22.0685C2.05948 21.7839 1.99878 21.4789 1.99878 21.1708C1.99878 20.8627 2.05948 20.5577 2.17741 20.2731C2.29535 19.9885 2.4682 19.73 2.6861 19.5122L19.1 3.09836C19.3178 2.88066 19.5764 2.708 19.861 2.59025C20.1456 2.4725 20.4506 2.41197 20.7585 2.41211H29.1609C29.7827 2.41211 30.3792 2.65915 30.8189 3.0989C31.2586 3.53864 31.5057 4.13506 31.5057 4.75695V13.1655C31.5051 13.7872 31.2577 14.3832 30.8179 14.8225"
				stroke="#D9654C"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="25.0966" cy="8.27577" r="1.37587" fill="#D9654C" stroke="#D9654C" />
			<path
				d="M17.2412 27.0329C17.2412 29.2095 18.1059 31.297 19.645 32.8361C21.1841 34.3752 23.2715 35.2398 25.4481 35.2398C27.6247 35.2398 29.7122 34.3752 31.2513 32.8361C32.7904 31.297 33.6551 29.2095 33.6551 27.0329C33.6551 24.8563 32.7904 22.7688 31.2513 21.2297C29.7122 19.6906 27.6247 18.826 25.4481 18.826C23.2715 18.826 21.1841 19.6906 19.645 21.2297C18.1059 22.7688 17.2412 24.8563 17.2412 27.0329V27.0329Z"
				stroke="#2D5098"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M35.9999 37.5847L31.2883 32.8731" stroke="#2D5098" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};
